export default "__VITE_ASSET__B2kZitZ2__"